/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'health-monitor';
const componentName = 'ping-health-monitor-config';
const prefix = `${moduleName}.${componentName}`;

export const sectionTitlePing = `${prefix}.sectionTitlePing`;

export const ENGLISH = {
    [sectionTitlePing]: 'Ping',
};
